import en from "./en.json";
import de from "./de.json";

export default { en, de };
